import React, { useState, useMemo, useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { AdminXsMenu } from '../../component/admin/AdminXsMenu'
import { Grid, Typography, Button, TextField } from '@mui/material'
import { Navbar } from '../../component/shared/Navbar'
import AddIcon from '@mui/icons-material/Add'
import Table from './Table'
import { debounce } from 'lodash'
import { PageContainer } from '../../component/styled/PageContainer'

export const GmnPage = () => {
  const [open, setOpen] = useState(false)
  const [searchKey, setSearchKey] = useState('')

  const handleSearch = useMemo(() => debounce((value) => setSearchKey(value), 500), [])

  // Any pending debounced call is canceled on unmount
  useEffect(() => {
    return () => {
      handleSearch.cancel()
    }
  }, [handleSearch])

  return (
    <>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Golden Moon Night Admin</title>
      </Helmet>
      <Navbar />
      <PageContainer>
        <Grid container spacing={2} py={5} px={1}>
          <Grid item xs={12} display='flex' justifyContent='space-between' alignItems='center'>
            <Typography variant='h1'>Golden Moon Night Admin</Typography>
            <AdminXsMenu />
          </Grid>
          <Grid item xs={12} display='flex' gap={2}>
            <TextField
              label='Search'
              variant='outlined'
              onChange={(e) => handleSearch(e.target.value)}
              placeholder='Name / ID'
              fullWidth
            />
            <Button
              startIcon={<AddIcon style={{ color: '#FFFFFF' }} />}
              variant='contained'
              color='primary'
              onClick={() => setOpen(true)}
              size='large'
            >
              Create
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Table open={open} setOpen={setOpen} searchKey={searchKey} isEdit={false} />
          </Grid>
        </Grid>
      </PageContainer>
    </>
  )
}
